import { render, staticRenderFns } from "./complainsrtdialog.vue?vue&type=template&id=59882a49&scoped=true"
import script from "./complainsrtdialog.vue?vue&type=script&lang=js"
export * from "./complainsrtdialog.vue?vue&type=script&lang=js"
import style0 from "./complainsrtdialog.vue?vue&type=style&index=0&id=59882a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59882a49",
  null
  
)

export default component.exports